import React, { useEffect, useState } from "react";
import Queries from "./Queries";
import * as utils from "../../Utils/comman";
import ReplyModal from "./ReplyModal";
function QueryList({ meetingId, empId, trigger }) {
  const [queryList, setQueryList] = useState([]);
  const [replyTo, setReplyTo] = useState(null);

  useEffect(() => {
    if (meetingId) fetchQueries();
  }, [meetingId, trigger]);

  const fetchQueries = () => {
    utils
      .callAPI("get", `/meeting/popupgift/list-query?popup_request_id=${meetingId}&parent_id=0`)
      .then((res) => {
        if (Array.isArray(res)) {
          const formatted = res.map((q) => ({
            ...q,
            employeeName: `${q.firstName?.trim()} ${q.lastName?.trim()}`,
            message: q.query,
            timestamp: q.createdAt,
            replies: [],
          }));
          setQueryList(formatted);
        } else {
          setQueryList([]);
        }
      });
  };

  const fetchReplies = async (parentId) => {
    const res = await utils.callAPI(
      "get",
      `/meeting/popupgift/list-query?popup_request_id=${meetingId}&parent_id=${parentId}`
    );
    if (!Array.isArray(res)) return;

    const formattedReplies = res.map((q) => ({
      ...q,
      employeeName: `${(q.firstName || "").trim()} ${(
        q.lastName || ""
      ).trim()}`,
      message: q.query,
      timestamp: q.createdAt,
      replies: [],
    }));

    const updateReplies = (list) =>
      list.map((q) => {
        if (q.id === parentId) {
          return { ...q, replies: formattedReplies };
        } else if (q.replies?.length) {
          return { ...q, replies: updateReplies(q.replies) };
        }
        return q;
      });

    setQueryList((prevList) => updateReplies(prevList));
  };

  return (
    <>
      <h6>All FeedBacks</h6>
      <hr />
      {queryList.length === 0 ? (
        <p className="text-muted text-center">No feedBack found.</p>
      ) : (
        queryList.map((query) => (
          <Queries
            key={query.id}
            query={query}
            replies={query.replies}
            onReply={setReplyTo}
            fetchReplies={fetchReplies}
          />
        ))
      )}

      <ReplyModal
        show={!!replyTo}
        onHide={() => setReplyTo(null)}
        commentData={replyTo}
        meetingId={meetingId}
        refreshList={fetchQueries}
      />
    </>
  );
}

export default QueryList;
